import Vue from 'vue'
import * as apiService from 'API/delivery'
import { deepClone } from 'Utils/functions'
import { notifySuccess } from 'Utils/notify'
import { notifyError } from '../../../utils/notify'

const emptySettings = {
  id: '',
  deliveryHorizont: '',
  height: '',
  width: '',
  length: '',
  volume: '',
  weight: ''
}

export default {
  namespaced: true,
  state: () => ({
    settings: deepClone(emptySettings)
  }),
  getters: {
    deserializeSettings: () => (settings) => ({
      id: settings.id,
      deliveryHorizont: settings.delivery_boundaries,
      height: settings.max_height,
      width: settings.max_width,
      length: settings.max_length,
      volume: settings.max_volume,
      weight: settings.max_weight
    }),
    serializeSettings: (state, getters, rootState) => () => ({
      id: state.settings.id,
      shop_id: rootState.storeModule.currentStore.id,
      delivery_boundaries: +state.settings.deliveryHorizont,
      max_height: +state.settings.height,
      max_length: +state.settings.length,
      max_width: +state.settings.width,
      max_volume: +state.settings.volume,
      max_weight: +state.settings.weight
    })
  },
  actions: {
    async getSettings({ commit, getters }, storeId) {
      try {
        let { data } = await apiService.getSettingsByStoreId(storeId)
        if (data.list.length === 0) {
          await apiService.createSetting({
            shop_id: storeId
          })
          data = await apiService.getSettingsByStoreId(storeId)
        }
        commit('setSettings', getters.deserializeSettings(data.list[0]))
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async submitSettings({ getters }) {
      try {
        await apiService.updateSettings(getters.serializeSettings())
        notifySuccess('Настройки успешно сохранены')
      } catch (e) {
        console.error(e)
        notifyError(e.response?.data?.error)
        throw e
      }
    }
  },
  mutations: {
    setSettings(state, settings) {
      Vue.set(state, 'settings', settings)
    },
    updateSettings(state, patch) {
      Vue.set(state, 'settings', {
        ...state.settings,
        ...patch
      })
    }
  }
}
